import { jsx as r } from "react/jsx-runtime";
import s from "react";
import t from "styled-components";
import { I as d } from "../chunks/vendor_rango__assets.57b7cd48.js";
import { R as u } from "../chunks/index.cff5baaf.js";
const a = t(u).withConfig({
  displayName: "Icon",
  componentId: "sc-wx2164-0"
})([""]), h = t.div.withConfig({
  displayName: "IconShapeProductContainer",
  componentId: "sc-wx2164-1"
})(["display:flex;align-items:center;justify-content:center;flex:0 0 auto;border-radius:var(--border-radius-circular);background-color:var(--color-lemon-400);", "{color:var(--color-green-800);}", ""], a, (o) => {
  if (o.size === e.SM)
    return `
                width: var(--size-6x);
                height: var(--size-6x);
            `;
  if (o.size === e.MD)
    return `
                width: var(--size-8x);
                height: var(--size-8x);
            `;
  if (o.size === e.LG)
    return `
                width: var(--size-10x);
                height: var(--size-10x);
            `;
}), z = Object.keys(d), e = {
  SM: "SM",
  MD: "MD",
  LG: "LG"
};
Object.values(e);
const p = s.forwardRef(({
  size: o = e.MD,
  icon: n,
  ...i
}, c) => /* @__PURE__ */ r(h, { size: o, ref: c, ...i, "data-testid": "rango-icon-shape-product", "data-rango-component": "rango-icon-shape-product", "data-is-rango": !0, children: /* @__PURE__ */ r(a, { icon: n, size: o }) }));
p.displayName = "RangoIconShapeProduct";
export {
  e as IconShapeProductSize,
  p as RangoIconShapeProduct,
  z as iconShapeProductSetTypeArray
};
